// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isEqual/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isEqual = convertToFP(fn, 2);
export default isEqual;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isEqual/index.js
// module id = 922
// module chunks = 0